import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui-kit/themeStyle';
import styled from 'styled-components';

import { FlexColumn, FlexRow } from 'styles/layouts';

export const SIDE_PANEL_WIDTH = 246;

export const SidebarWrapper = styled(FlexColumn)<{ hasBanner?: boolean }>`
  padding-top: ${({ hasBanner }) =>
    hasBanner ? 'var(--banner-height)' : '0px'};
  box-sizing: border-box;
  height: 100%;

  & > * {
    box-sizing: border-box;
  }
`;

export const SidebarHeader = styled(FlexRow)`
  padding: 13px var(--spacing-8);
`;

export const SidebarSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--spacing-8);

  &:last-child {
    flex: 1;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${themeStyle.colorBorder};
  }
`;

export const SidebarContent = styled.nav`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-12);
  padding: var(--spacing-8);
`;

export const SidebarFooter = styled(FlexColumn)`
  padding: var(--spacing-8);
  margin-top: auto;
  gap: var(--spacing-8);
`;

export const NavigationMenu = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const SideBarBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: var(--z-index-s2);

  ${QUERIES.largeTabletAndUp} {
    display: none;
  }
`;

export const SidebarLayout = styled(FlexColumn)<{ isOpened: boolean }>`
  width: ${SIDE_PANEL_WIDTH}px;
  min-width: ${SIDE_PANEL_WIDTH}px;
  max-width: ${SIDE_PANEL_WIDTH}px;
  border-right: 1px solid ${themeStyle.colorBorder};
  position: fixed;
  left: ${({ isOpened }) => (isOpened ? 0 : -SIDE_PANEL_WIDTH)}px;
  height: 100%;
  z-index: var(--z-index-s3);
  top: 0;
  background: var(--color-bg-surface);
  transition: left ${themeStyle.motionDuration300};

  ${QUERIES.largeTabletAndUp} {
    height: 100vh;
    position: sticky;
    top: 0;
    left: 0;
  }
`;
